import jsonBigInt from 'json-bigint';

const jsonBigString = jsonBigInt({ storeAsString: true });

export const parseToString = jsonBigString.parse;
